import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
const Landing = () => {
  const navigate = useNavigate();
  const { mode } = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default'
      }}
    >
      {/* Header */}
      <Box
        sx={{
          py: 2,
          px: 4,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <img
            src={mode === "dark" ? "banner_light.png" : "banner.png"}
            alt="Banner"
            style={{ width: '160px', height: 'auto' }}
          />
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>


          <Button
            variant="outlined"
            onClick={() => navigate('/login')}
          >
            Login
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate('/signup')}
          >
            Sign Up
          </Button>
        </Box>
      </Box>

      {/* Main Content */}
      <Container
        maxWidth="xl"
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          py: 4,
          px: { xs: 2, sm: 8, md: 15 }
        }}
      >
        {/* Left Side */}
        <Box sx={{ maxWidth: '50%' }}>
          <Typography 
            variant="h1" 
            sx={{ 
              mb: 3,
              fontSize: { xs: '2.5rem', md: '3rem' },
              fontWeight: 700,
              lineHeight: 1.2
            }}
          >
            Generate Tweets 
            <br />
            Engineered for <Box component="span" sx={{ 
              background: 'linear-gradient(45deg,rgb(78, 178, 232),rgb(30, 127, 212))',
              backgroundSize: '200% 200%',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              animation: 'gradient 5s ease infinite',
              '@keyframes gradient': {
                '0%': {
                  backgroundPosition: '0% 50%'
                },
                '50%': {
                  backgroundPosition: '100% 50%'
                },
                '100%': {
                  backgroundPosition: '0% 50%'
                }
              }
            }}>Virality</Box>
          </Typography>
          <Typography
            variant="h6"
            sx={{
              mb: 4,
              color: 'text.secondary',
              fontWeight: 400,
              lineHeight: 1.5
            }}
          >
          We reverse-engineered the patterns behind 1000's of viral tweets and then trained an AI on them. 
          Paste your content, and let AI re-package it into tweets optimized for virality and growth.
          </Typography>

          <Button
              type="submit"
              variant="contained"
              size="large"
              onClick={() => navigate('/signup')}
              sx={{
                // color: 'primary.contrastText',
                px: 2.5,
                py: 1.5,
                fontSize: '1.1rem',
              }}
            >
              ✨ Get Started for Free
            </Button>
          <Typography
            variant="body1"
            sx={{
              mt: 3,
              color: 'text.secondary',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            Join 1,430+ content creators already using RapidTweets
          </Typography>
        </Box>

        {/* Right Side - Video Demo */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            bgcolor: 'background.paper',
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: 10,
          }}
        >
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              objectFit: 'cover'
            }}
          >
            <source src="/landing_page_demo.mp4" type="video/mp4" />
          </video>
        </Box>
      </Container>

      {/* Footer */}
      <Box
        sx={{
          py: 3,
          px: 4,
          borderTop: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Typography variant="body2" color="text.secondary">
          © 2025 RapidTweets. All rights reserved.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Made with ❤️ by doom-scrollers
        </Typography>
      </Box>
    </Box>
  );
};

export default Landing; 